import { StyleSheet } from 'react-native';

import { C } from '../../common';
import { LAYOUT, THEME } from '../../reactor/common';

const { CONTENT_MAX_WIDTH } = C;
const { UNIT, OFFSET } = THEME;

export default StyleSheet.create({
  buttonClose: {
    alignSelf: 'flex-end',
    position: 'absolute',
    right: -OFFSET,
    top: -UNIT,
  },

  container: {
    justifyContent: 'flex-end',
    padding: OFFSET,
  },

  frame: {
    maxWidth: CONTENT_MAX_WIDTH / 2,
    width: '100%',
  },

  image: {
    height: UNIT * 4.8,
    width: UNIT * 12,
  },

  row: {
    ...LAYOUT.STYLE.ROW,
    marginTop: OFFSET,
  },

  rowCentered: {
    justifyContent: 'space-between',
    alignItems: 'center',
    alignContent: 'center',
  },

  title: {
    marginRight: OFFSET * 2,
  },
});
